import React, {Component} from 'react'
import TextsmsIcon from '@material-ui/icons/Textsms';
import FaceIcon from '@material-ui/icons/Face';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import GroupIcon from '@material-ui/icons/Group';
//import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';
import './ChatRoom.css'
import FlashCountBadge from '../FunctionArea/FlashCountBadge'
import ChatRoomExpandArea from './ChatRoomExpandArea'


class ChatRoom extends Component {
    constructor(props) {
        super(props)
        this.state = {
            shrink:true,
            expandContain:null
        }
    }

    componentDidMount(){

    }

    componentDidUpdate(prevProps){
      
    }

    rowContainer=()=>{        
        return <div>{this.createShrinkContainer()}</div>    
    }


    createShrinkContainer=()=>{
        return <div>
                    <div className={"chatRoomMainRowContainer"} onClick={this.expandUnreadArea}>
                        <div className={"userCountRow"} >
                            <div className={"userCountTitle"}>
                                <TextsmsIcon fontSize={"large"}/>
                            </div>
                            <div className={"messageNumberBadge"}>
                                <FlashCountBadge countNumber={this.props.unreadMessage.length} badgeType={"red-blue"}/>
                            </div>
                        </div>
                        <div className={"userCountRowTitle"}>{"內部使用者訊息"}</div>
                    </div>
                    <div className={"chatRoomMainRowContainer"} onClick={this.expandUserList}>
                        <div className={"userCountRow"} >
                            <div className={"userCountTitle"}>
                                <FaceIcon fontSize={"large"}/>
                            </div>
                            <div className={"messageNumberBadge"}>
                                <FlashCountBadge countNumber={this.props.currentUsers? Object.keys(this.props.currentUsers).length : "0"} badgeType={"blue"}/>
                            </div>
                        </div>
                        <div className={"userCountRowTitle"}>{"線上內部使用者"}</div>
                    </div>
                    <div className={"chatRoomMainRowContainer"} onClick={this.expandUnreadQueryArea}>
                        <div className={"userCountRow"} >
                            <div className={"userCountTitle"}>
                                <LiveHelpIcon fontSize={"large"}/>
                            </div>
                            <div className={"messageNumberBadge"}>
                                <FlashCountBadge countNumber={this.props.unreadQuery.length} badgeType={"red-blue"}/>
                            </div>
                        </div>
                        <div className={"userCountRowTitle"}>{"外部參觀者訊息"}</div>
                    </div>
                    <div className={"chatRoomMainRowContainer"} onClick={this.expandVisitorList}>
                        <div className={"userCountRow"} >
                            <div className={"userCountTitle"}>
                                <GroupIcon fontSize={"large"}/>
                            </div>
                            <div className={"messageNumberBadge"}>
                                <FlashCountBadge countNumber={this.props.currentVisitors? Object.keys(this.props.currentVisitors).length : "0"} badgeType={"blue"}/>
                            </div>
                        </div>
                        <div className={"userCountRowTitle"}>{"線上外部參觀者"}</div>
                    </div>
                </div>
    }

    shrinkContainer=()=>{
        this.setState({
            shrink:true,
            expandContain:null
        })
    }

    expandUnreadArea=()=>{
        this.setState({
            shrink:false,
            expandContain:"unreadMessageList"
        })
    }

    expandUserList=()=>{
        this.setState({
            shrink:false,
            expandContain:"userList"
        })
    }

    expandUnreadQueryArea=()=>{
        this.setState({
            shrink:false,
            expandContain:"unreadQueryList"
        })
    }

    expandVisitorList=()=>{
        this.setState({
            shrink:false,
            expandContain:"visitorList"
        })
    }

    invokeChatChannel=(user)=>{
        this.props.getChatChannel(user)
    }

    invokeQueryChannel=(visitor)=>{
        this.props.getQueryChannel(visitor)
    }

    render(){
        return(
            <div className={"chatRoom"}>
                {this.state.shrink?
                null
                :
                <ChatRoomExpandArea allUsers={this.props.allUsers} currentUsers={this.props.currentUsers} currentVisitors={this.props.currentVisitors} getChatChannel={this.invokeChatChannel} getQueryChannel={this.invokeQueryChannel} unreadMessage={this.props.unreadMessage} unreadQuery={this.props.unreadQuery} userID={this.props.userID} expandContain={this.state.expandContain} getCloseExpandContainClose={this.shrinkContainer}/>
                }                
                {this.rowContainer()}              
            </div>    
        )
    }
}

export default ChatRoom